export const REPORT_TYPES = [
  { value: 'dashboard', label: 'Dashboard' },
  { value: 'overall', label: 'Overall Standings' },
  { value: 'byTeam', label: 'By Team' },
  { value: 'byEvent', label: 'By Event' },
  { value: 'byCategory', label: 'By Category' },
  { value: 'byDivision', label: 'By Division' },
  { value: 'missing', label: 'Missing Scores' },
  { value: 'scores1500', label: 'Scores = 1500' },
];
